// src/config.js
const API_BASE_URL = 'https://api.granturisbro.com';
const IMAGES_BASE_URL = 'https://images.granturisbro.com';
// const HOME_URL = 'https://gt7.granturisbro.com';

const COUNTRY_FLAGS = {
    'Japan': '🇯🇵',
    'Germany': '🇩🇪',
    'United States': '🇺🇸',
    'Italy': '🇮🇹',
    'France': '🇫🇷',
    'United Kingdom': '🇬🇧',
    'Austria': '🇦🇹',
    'South Korea': '🇰🇷',
    'Czech': '🇨🇿',
    'Sweden': '🇸🇪',
  };


export { API_BASE_URL, COUNTRY_FLAGS, IMAGES_BASE_URL };